import { render, staticRenderFns } from "./RegionPricingDetail.vue?vue&type=template&id=459b7fb2"
import script from "./RegionPricingDetail.vue?vue&type=script&lang=js"
export * from "./RegionPricingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports